const SouthKoreaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112405)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M26.9564 19.9995C26.9564 21.7386 23.8419 26.0864 19.9999 26.0864C16.158 26.0864 13.0435 21.7386 13.0435 19.9995C13.0435 16.1574 16.158 13.043 19.9999 13.043C23.8419 13.043 26.9564 16.1574 26.9564 19.9995Z"
        fill="#D80027"
      />
      <path
        d="M26.9564 20C26.9564 23.842 23.8419 26.9565 19.9999 26.9565C16.158 26.9565 13.0435 23.842 13.0435 20"
        fill="#0052B4"
      />
      <path
        d="M27.373 26.1484L29.2174 24.3041L30.4469 25.5337L28.6026 27.378L27.373 26.1484Z"
        fill="black"
      />
      <path
        d="M24.2988 29.2227L26.1432 27.3783L27.3727 28.6079L25.5284 30.4522L24.2988 29.2227Z"
        fill="black"
      />
      <path
        d="M31.062 29.8369L32.9063 27.9926L34.1359 29.2222L32.2916 31.0665L31.062 29.8369Z"
        fill="black"
      />
      <path
        d="M27.9873 32.9121L29.8316 31.0678L31.0612 32.2974L29.2169 34.1417L27.9873 32.9121Z"
        fill="black"
      />
      <path
        d="M29.2168 27.9932L31.0611 26.1488L32.2907 27.3784L30.4464 29.2227L29.2168 27.9932Z"
        fill="black"
      />
      <path
        d="M26.1436 31.0674L27.9879 29.2231L29.2175 30.4526L27.3731 32.297L26.1436 31.0674Z"
        fill="black"
      />
      <path
        d="M31.0698 13.8545L26.1516 8.93626L27.3812 7.70669L32.2994 12.6249L31.0698 13.8545Z"
        fill="black"
      />
      <path
        d="M26.1504 12.626L24.3061 10.7816L25.5356 9.55213L27.3799 11.3965L26.1504 12.626Z"
        fill="black"
      />
      <path
        d="M29.2251 15.6992L27.3808 13.8549L28.6103 12.6254L30.4546 14.4697L29.2251 15.6992Z"
        fill="black"
      />
      <path
        d="M29.8394 8.93652L27.995 7.09219L29.2246 5.86262L31.0689 7.70695L29.8394 8.93652Z"
        fill="black"
      />
      <path
        d="M32.9146 12.0117L31.0702 10.1674L32.2998 8.93782L34.1441 10.7821L32.9146 12.0117Z"
        fill="black"
      />
      <path
        d="M7.08984 27.9902L12.0081 32.9085L10.7785 34.138L5.86027 29.2198L7.08984 27.9902Z"
        fill="black"
      />
      <path
        d="M12.0083 29.2188L13.8526 31.0631L12.6231 32.2926L10.7788 30.4483L12.0083 29.2188Z"
        fill="black"
      />
      <path
        d="M8.93359 26.1455L10.7779 27.9898L9.54835 29.2194L7.70402 27.3751L8.93359 26.1455Z"
        fill="black"
      />
      <path
        d="M10.7788 24.3008L15.697 29.219L14.4675 30.4486L9.54924 25.5304L10.7788 24.3008Z"
        fill="black"
      />
      <path
        d="M12.0083 7.08789L7.09007 12.0061L5.86049 10.7766L10.7787 5.85832L12.0083 7.08789Z"
        fill="black"
      />
      <path
        d="M13.8521 8.93066L8.93382 13.8489L7.70424 12.6193L12.6225 7.70109L13.8521 8.93066Z"
        fill="black"
      />
      <path
        d="M15.6987 10.7773L10.7805 15.6956L9.55098 14.4661L14.4692 9.54783L15.6987 10.7773Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112405">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SouthKoreaSvg;
